import React from "react";
import WorkspacesComponent from "../../../modules/workspaces/components/list/workspaces/workspaces-component.component";

export default function WorkspacesPage() {
  return <WorkspacesComponent />;
}
